import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入Vue Router
import VueRouter from 'vue-router'
import Vuex from 'vuex'


// 导入组件
import HomePage from './components/HomePage.vue'
import Dashboard from './components/Dashboard.vue'
import HollandTest from './components/HollandTest.vue' // 导入新组件
import AdminDashboard from './components/AdminDashboard.vue' // 新增：导入管理员后台组件
import Login from './components/Login.vue' // 新增：导入登录组件
import Register from './components/Register.vue' // 新增：导入注册组件
import MajorsList from './components/MajorsList.vue' // 新增：导入专业列表组件
import { getCookie } from '@/utils'
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex) // 注册 Vuex

// 创建 Vuex Store
const store = new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem('user')) || {
      isLoggedIn: false,
      username: '',
      displayName: '',
      isSuperAdmin: ""
    }
  },
  mutations: {
    // 使用大写命名规范
    SET_USER(state, userInfo) {
      state.user = userInfo;
      localStorage.setItem('user', JSON.stringify(userInfo));
    },
    SET_LOGIN_STATUS(state, status) {
      state.user.isLoggedIn = status;
      localStorage.setItem('user', JSON.stringify(state.user));
    }
  },
  actions: {
    checkLoginStatus({ commit }) {
      // const csrftoken = getCookie('csrftoken');

      return axios.get('api/check-login/', {
        // withCredentials: true,
        // headers: { 'X-Csrftoken': csrftoken }
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      }
    )
      .then(response => {
        commit('SET_USER', {
          isLoggedIn: response.data.isLoggedIn,
          username: response.data.username,
          displayName: response.data.displayName || response.data.username,
          isSuperAdmin: response.data.isSuperAdmin
        });
        return response;
      })
      .catch(error => {
        console.error('检查登录状态失败:', error);
        commit('SET_USER', {
          isLoggedIn: false,
          username: '',
          displayName: '',
          isSuperAdmin: '用户'
        });
        throw error;
      });
    }
  }
})



// 配置Axios - 根据不同环境使用不同的API地址
// 开发环境默认使用相对路径（通过Vue代理），生产环境使用线上地址
if (process.env.NODE_ENV === 'production') {
  // 生产环境API地址 - 统一使用yuanbida.net
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || 'https://yuanbida.net';
} else {
  // 开发环境使用相对路径，让Vue代理处理请求
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || '';
}

// 允许携带跨域Cookie
axios.defaults.withCredentials = true;
// 配置 XSRF 令牌（如果需要）
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-Csrftoken'
// 添加CSRF令牌处理
// 从cookie中获取CSRF令牌的函数
// function getCookie(name) {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts.length === 2) return parts.pop().split(';').shift();
// }

// 设置请求拦截器，自动添加CSRF令牌到请求头
axios.interceptors.request.use(config => {
  // 对于POST、PUT、PATCH、DELETE请求，添加CSRF令牌
  if (['post', 'put', 'patch', 'delete'].includes(config.method.toLowerCase())) {
    const csrfToken = getCookie('csrftoken');
    if (csrfToken) {
      config.headers['X-Csrftoken'] = csrfToken;
    }
  }
  return config;
});

// 定义路由
const routes = [
  { path: '/', component: HomePage },
  { path: '/home', component: HomePage },
  { path: '/dashboard', component: Dashboard },
  { path: '/holland-test', name: 'HollandTest', component: HollandTest },
  { path: '/admin', component: AdminDashboard } ,// 新增：管理员后台路由
  {path: '/login', name: 'Login',component: Login},
  {path: '/register',name: 'Register',component: Register},
  {path: '/majors', name: 'MajorsList', component: MajorsList} // 新增：专业列表路由
]

// 创建路由实例
const router = new VueRouter({
  // routes
  // // 将mode从默认的hash改为history
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

new Vue({
  el: '#app',  // This matches the id in index.html
  render: h => h(App),
  router,
  store // 挂载 store
})
